import { BackgroundColor } from "@silversea-ssc/ui-components-react";
import LinkCard, { LinkCardProps } from "components/Card/LinkCard";
import MultiLine from "components/Text/MultiLine";
import React from "react";
import { PageBuilderCardSliderItemFragment } from "types/graphql-types";
import PageBuilderButtonCTA from "../PageBuilderButtonCTA";

type Props = PageBuilderCardSliderItemFragment & {
  cardBackgroundColor?: BackgroundColor;
  imageRatio?: LinkCardProps["imageRatio"];
};

const PageBuilderCardSliderItem: React.FC<React.PropsWithChildren<Props>> = ({
  cardBackgroundColor,
  image,
  imageRatio,
  title,
  description,
  ctaButtons
}) => {
  const ctaButton = ctaButtons && ctaButtons.length > 0 && ctaButtons[0];

  return (
    <LinkCard
      backgroundColor={cardBackgroundColor}
      image={image}
      imageRatio={imageRatio}
      title={title?.localized}
      description={<MultiLine>{description?.localized}</MultiLine>}
      action={{
        button: (
          <PageBuilderButtonCTA
            {...ctaButton}
            variant="link"
            defaultButtonVariant="text"
          />
        )
      }}
    />
  );
};

export default PageBuilderCardSliderItem;
